<template>
  <div class="data-table">
    <el-table
      :data="tableData"
      border
      stripe
      :height="scroll ? 300: null"
      @sort-change="sortChange"
    >
      <el-table-column
        v-for="column in tableColumn"
        :key="column.key"
        :prop="column.key"
        :sortable="column.sortable"
        :label="column.label"
        :width="column.width"
      >
        <template
          slot="header"
        >
          {{ column.label }}
          <el-tooltip
            v-if="column.tips"
            effect="dark"
            :content="column.tips"
            placement="top-start"
          >
            <i class="el-icon-question" />
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <span v-if="formatColumn(column,scope) !== 'component'">

            <el-tooltip
              v-if="column.substr"
              effect="dark"
              :content="formatColumn(column,scope)"
              placement="top-start"
            >
              <span>{{ untils.substr(formatColumn(column,scope), column.substr) }}</span>
            </el-tooltip>
            <span v-else>
              {{ formatColumn(column,scope) }}
            </span>
          </span>
          <span v-else>
            <!-- status -->
            <component
              :is="column.render()"
              v-if="column.render() === 'status' "
              :is-success="Number(scope.row[column.key]) === column.renderProps.successKey"
            >
              {{ column.renderProps[scope.row[column.key]] }}
            </component>
            <!-- status end-->
            <!-- radio -->
            <el-radio
              v-if="column.render() === 'radio'"
              v-model="scope.row[column.key]"
              :label="1"
              @change="changeRadio(scope.row, column.key)"
            />
            <!-- radio -->
            <!-- checkbox -->
            <el-checkbox
              v-if="column.render() === 'checkbox'"
              v-model="scope.row[column.key]"
              :true-label="1"
              :false-label="0"
              @change="changeCheckbox(scope.row, column)"
            />
            <!-- checkbox -->
            <!-- checkbox -->
            <el-checkbox
              v-if="column.render() === 'checkboxSingle'"
              v-model="scope.row[column.key]"
              :true-label="1"
              :false-label="0"
              @change="changeCheckboxSingle(scope.row, column.key)"
            />
            <!-- checkbox -->
            <!-- buttons -->
            <div v-if="column.render() === 'buttons'">
              <el-button
                v-for="(prop,i) in column.renderProps"
                v-if="prop.renderKey === null || prop.renderKey === scope.row[prop.renderProp]"
                :key="i"
                size="mini"
                :type="prop.type"
                plain
                :disabled="prop.disableKey !== null && prop.disableKey === scope.row[prop.disableProp]"
                @click="clickButton(prop.eventIndex, scope.row)"
              >
                {{ prop.text }}
              </el-button>
            </div>
            <!-- buttons end-->
            <!-- image -->
            <el-image
              v-if="column.render() === 'image'"
              style="width: 100%;"
              :src="scope.row[column.key].split(',')[0]"
              :preview-src-list="scope.row[column.key].split(',')"
            />
            <!-- image end-->
          </span>
        </template>
      </el-table-column>
    </el-table>
    <div
      v-if="pagination"
      class="pagination"
    >
      <el-pagination
        :page-sizes="[10, 20]"
        :page-size="pageSize"
        :current-page="pageNum"
        background
        layout="total, sizes, prev, pager, next"
        :total="data.total"
        @current-change="changePagination"
        @size-change="changePaginationSize"
      />
    </div>
  </div>
</template>
<script>

import status from '@/components/common/status.vue';
import types from '@/config';
import untils from '@/util';

export default {
  name: 'DataTable',
  components: { status },
  props: {
    pagination: {
      default: false,
      type: Boolean,
    },
    data: {
      default: () => [],
      type: [Object, Array],
    },
    tableColumn: {
      default: () => ([]),
      type: Array,
    },
    scroll: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      types,
      untils,
    };
  },
  computed: {
    pageSize() {
      return this.data.pageSize;
    },
    pageNum() {
      return this.data.pageNum;
    },
    tableData() {
      if (this.pagination) {
        return this.data.list;
      }
      return this.data;
    },
  },
  methods: {
    // radio change
    changeRadio(item, key) {
      this.tableData.forEach((col) => {
        col[key] = 0;
      });
      item[key] = 1;
      this.$emit('changeRadio', item);
    },
    // checkbox change
    changeCheckbox(item) {
      this.$emit('changeCheckbox', item);
    },
    // changeCheckboxSingle change
    changeCheckboxSingle(item, key) {
      if (item[key] === 1) {
        this.$emit('changeCheckboxSingle', item);
      } else {
        this.$emit('changeCheckboxSingle', {});
      }
    },
    // 处理column 参数
    formatColumn(column, scope) {
      let tpl = '';
      const rowData = scope.row[column.key];
      switch (column.dataType) {
        case 'text':
          if (!rowData) {
            const unit = column.unit ? column.unit : '';
            if (column.default) {
              tpl = column.default + unit;
            } else {
              tpl = '--';
            }
          } else {
            const unit = column.unit ? column.unit : '';
            tpl = rowData + unit;
          }
          break;
        case 'money':
          tpl = `${(Number(rowData) / 100).toFixed(2)}元`;
          break;
        case 'time':
          if (rowData) {
            tpl = this.$time(Number(rowData)).format('YYYY/MM/DD HH:mm');
          } else {
            tpl = '----';
          }
          break;
        case 'function':
          tpl = column.render(rowData).map((v) => v.label).join();
          break;
        case 'component':
          tpl = column.dataType;
          break;
        default:
      }
      return tpl;
    },
    // 操作按钮事件
    clickButton(value, item) {
      this.$emit('buttonClick', value, item);
    },
    // 分页器
    changePagination(val) {
      this.$emit('changeBypagination', val, this.pageSize);
    },
    changePaginationSize(val) {
      this.$emit('changeBypagination', this.pageNum, val);
    },
    // 排序
    sortChange(data) {
      this.$emit('sortChange', { prop: data.prop, order: data.order });
    },
  },
};
</script>
<style lang="scss" scoped>
.data-table {
  &.scroll{
    overflow: auto;
    height: 280px;
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
  ::v-deep .el-radio__label {
    display: none;
  }
}
</style>
